import { render, staticRenderFns } from "./didend.vue?vue&type=template&id=3566ccfd&scoped=true&"
import script from "./didend.vue?vue&type=script&lang=js&"
export * from "./didend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566ccfd",
  null
  
)

export default component.exports